import React, { Component } from 'react'
import { Link } from 'react-router'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import style from './style.module.less'
import Title from './Info/title'
import Operator from './Info/operator'
import Table from './Table'
import { CASE_MANAGE_PATH } from '@constant'
import { getCaseManageTitle, getCaseName } from '@util'

const store = new Store()

class Index extends Component {
  constructor(props) {
    super(props)
    store.id = this.props.params.id
  }

  componentDidMount() {
    store.getInfo()
  }
  render() {
    const title = `${getCaseName()}分类`
    return (
      <HeaderView
        header={[
          <Link to={CASE_MANAGE_PATH}>{getCaseManageTitle()}</Link>,
          title
        ]}
        title={title}
      >
        <div className={style.unionPhotoWrap}>
          <Title store={store} />
          <Operator store={store} />
          <Table id={this.props.params.id} />
        </div>
      </HeaderView>
    )
  }
}

export default Index
